module.exports = __webpack_public_path__ + "build/desktop/img/nights.1bd0c3f663868d04270e0aa433475473.svg";